import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import cx from 'classnames';
import { alpha } from '@classify/react-core-components/styles';
import browser from '../../../browser';

const useStyles = makeStyles(
  ({ palette }) => ({
    root: {
      zIndex: 0,
      display: 'block',
      transition: 'all 0.1s linear 0s',
      boxSizing: 'border-box',
      marginTop: '0 !important',
      width: '100%',
      left: 0,
      position: 'relative',
    },
    container: {
      overflowX: 'auto',
    },
    shadow: {
      '&::before, &::after': {
        top: 0,
        bottom: 0,
        height: '100%',
        zIndex: 11,
        width: 8,
        position: 'absolute',
        display: 'none',
      },
    },
    leftShadow: {
      '&::before': {
        left: 0,
        display: 'block',
        background: `linear-gradient(to right, ${alpha(
          palette.text.secondary,
          0.24
        )} 0%, transparent 100%)`,
        content: '""',
      },
    },
    rightShadow: {
      '&::after': {
        right: 0,
        display: 'block',
        background: `linear-gradient(to left, ${alpha(
          palette.text.secondary,
          0.24
        )} 0%, transparent 100%)`,
        content: '""',
      },
    },
  }),
  { classNamePrefix: 'HorizontalScroller' }
);

export function HorizontalScroller({ children }) {
  const classes = useStyles();

  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);
  const [container, setContainer] = useState(null);

  const updateShadows = (e) => {
    const node = e?.target || e;

    if (!node) {
      return;
    }
    setContainer(node);

    const { scrollWidth, scrollLeft, clientWidth } = node;
    setShowLeftShadow(scrollLeft > 0);
    setShowRightShadow(scrollWidth - clientWidth !== scrollLeft);
  };

  useEffect(() => {
    const onResize = () => {
      updateShadows(container);
    };
    browser.window.addEventListener('resize', onResize);

    return () => {
      browser.window.removeEventListener('resize', onResize);
    };
  }, [container]);

  return (
    <div
      className={cx(classes.root, classes.shadow, {
        [classes.leftShadow]: showLeftShadow,
        [classes.rightShadow]: showRightShadow,
      })}
      onScroll={updateShadows}
    >
      <div className={classes.container} ref={updateShadows}>
        {children}
      </div>
    </div>
  );
}

export default HorizontalScroller;
